export enum OthersClockNotificationsEnum {
  None = 'none',
  Team = 'team',
}

export const OthersClockNotificationsEnumLabels: Record<OthersClockNotificationsEnum, string> = {
  [OthersClockNotificationsEnum.None]: 'Ninguna',
  [OthersClockNotificationsEnum.Team]: 'Mi equipo',
};

export const OthersClockNotificationsEnumDescriptions: Record<OthersClockNotificationsEnum, string> = {
  [OthersClockNotificationsEnum.None]: 'No recibirás notificaciones cuando fichan otras personas',
  [OthersClockNotificationsEnum.Team]: 'Recibirás notificaciones cuando fichan compañeros de tus proyectos activos',
};
